import React from 'react'
import TitleBg from '../components/TitleBg'
import bg from '../images/ContactUsBg.png';

function TermsOfServiceTitle() {
  return (
    <TitleBg
        title='Terms Of Service'
        bgImg={bg}
    />
  )
}

export default TermsOfServiceTitle